import styled from 'styled-components';

export const KeyStatistics3 = styled.div`
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: var('--color-on-background');
`;
